<template>
  <InfoBranch
    v-if="!!item.config"
    :content="item.meta.name"
    :style="{
      marginTop: '2px',
    }"
  />
</template>
<script>
import InfoBranch from '../utils/InfoBranch'
export default {
  name: 'TagRemove',
  components: {
    InfoBranch
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>